import { render, staticRenderFns } from "./peekaboo.vue?vue&type=template&id=27e78669"
import script from "./peekaboo.vue?vue&type=script&lang=js"
export * from "./peekaboo.vue?vue&type=script&lang=js"
import style0 from "./peekaboo.vue?vue&type=style&index=0&id=27e78669&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports